export const mapFontToFontFamily = (themeUtils, font) => {
  const fonts = themeUtils.getFonts();
  return fonts[font] && fonts[font].mapTo;
}

export const addPxSuffix = (value) => {
  return value + 'px';
}

export const setFontCSSVariablesBasedOnTheme = (theme, overriddenStyleId, themeUtils) => {
  const notebookStyleId = overriddenStyleId ? overriddenStyleId : theme.mappings.notebook;
  const notebookStyle = theme.notebooks.find(style => style.id === notebookStyleId);
  const pageBackground = theme.pages[0].background;
  const fontColor = notebookStyle.fontColor;
  const resolvedTextFontColor = themeUtils.getResolvedThemeColor(pageBackground, null, notebookStyle.backgroundColor, null, theme.colors, fontColor.value, fontColor.opacity);
  resolvedTextFontColor &&
    document.documentElement.style.setProperty(
      '--notebookTextColor',
      resolvedTextFontColor
    );
  const smartTextFontColor = notebookStyle.smartTextFontColor;
  const resolvedSmartTextFontColor = themeUtils.getResolvedThemeColor(pageBackground, null, notebookStyle.backgroundColor, null, theme.colors, smartTextFontColor.value, smartTextFontColor.opacity);
  resolvedSmartTextFontColor &&
    document.documentElement.style.setProperty(
      '--notebookSmartTextColor',
      resolvedSmartTextFontColor
    );

  const urlFontColor = notebookStyle.urlFontColor;
  const resolvedUrlFontColor = themeUtils.getResolvedThemeColor(pageBackground, null, notebookStyle.backgroundColor, null, theme.colors, urlFontColor.value, urlFontColor.opacity);
  resolvedUrlFontColor &&
    document.documentElement.style.setProperty(
      '--notebookUrlTextColor',
      resolvedUrlFontColor
    );

  const headerFontInfo = theme.fonts.find(f => f.id === notebookStyle.contentHeaderFont.value);
  const headerFontFamily = mapFontToFontFamily(themeUtils, headerFontInfo.family);
  headerFontFamily &&
    document.documentElement.style.setProperty(
      '--notebookHeaderFontFamily',
      headerFontFamily
    );
  headerFontInfo.size &&
    document.documentElement.style.setProperty(
      '--notebookHeaderSize',
      addPxSuffix(headerFontInfo.size)
    );
  headerFontInfo.weight &&
    document.documentElement.style.setProperty(
      '--notebookHeaderFontWeight',
      headerFontInfo.weight
    );
  headerFontInfo.style &&
    document.documentElement.style.setProperty(
      '--notebookHeaderStyle',
      headerFontInfo.style === 'Italic' ? 'italic' : 'normal'
    );

  const titleFontInfo = theme.fonts.find(f => f.id === notebookStyle.contentTitleFont.value);
  const titleFontFamily = mapFontToFontFamily(themeUtils, titleFontInfo.family);
  titleFontFamily &&
    document.documentElement.style.setProperty(
      '--notebookTitleFontFamily',
      titleFontFamily
    );
  titleFontInfo.size &&
    document.documentElement.style.setProperty(
      '--notebookTitleSize',
      addPxSuffix(titleFontInfo.size)
    );

  titleFontInfo.weight &&
    document.documentElement.style.setProperty(
      '--notebookTitleFontWeight',
      titleFontInfo.weight
    );
  titleFontInfo.style &&
    document.documentElement.style.setProperty(
      '--notebookTitleStyle',
      titleFontInfo.style === 'Italic' ? 'italic' : 'normal'
    );

  const subTitleFontInfo = theme.fonts.find(f => f.id === notebookStyle.contentSubtitleFont.value);
  const subTitleFontFamily = mapFontToFontFamily(themeUtils, subTitleFontInfo.family);
  subTitleFontFamily &&
    document.documentElement.style.setProperty(
      '--notebookSubTitleFontFamily',
      subTitleFontFamily
    );
  subTitleFontInfo.size && 
    document.documentElement.style.setProperty(
      '--notebookSubTitleSize',
      addPxSuffix(subTitleFontInfo.size)
    );
  subTitleFontInfo.weight &&
    document.documentElement.style.setProperty(
      '--notebookSubTitleFontWeight',
      subTitleFontInfo.weight
    );
  subTitleFontInfo.style &&
    document.documentElement.style.setProperty(
      '--notebookSubTitleStyle',
      subTitleFontInfo.style === 'Italic' ? 'italic' : 'normal'
    );
  
  const textFontInfo = theme.fonts.find(f => f.id === notebookStyle.contentTextFont.value);
  const textFontFamily = mapFontToFontFamily(themeUtils, textFontInfo.family);
  textFontFamily &&
    document.documentElement.style.setProperty(
      '--notebookTextFontFamily',
      textFontFamily
    );
  textFontInfo.size &&
    document.documentElement.style.setProperty(
      '--notebookTextSize',
      addPxSuffix(textFontInfo.size)
    );
  textFontInfo.weight &&
    document.documentElement.style.setProperty(
      '--notebookTextFontWeight',
      textFontInfo.weight
    );
  textFontInfo.style &&
    document.documentElement.style.setProperty(
      '--notebookTextStyle',
      textFontInfo.style === 'Italic' ? 'italic' : 'normal'
    );
};

export const setFontCSSVariablesBasedOnViewStyle = (viewStyle, themeUtils) => {
  viewStyle.textColor &&
    document.documentElement.style.setProperty(
      '--notebookTextColor',
      viewStyle.textColor
    );
  viewStyle.smartTextColor &&
    document.documentElement.style.setProperty(
      '--notebookSmartTextColor',
      viewStyle.smartTextColor
    );
  viewStyle.urlTextColor &&
    document.documentElement.style.setProperty(
      '--notebookUrlTextColor',
      viewStyle.urlTextColor
    );

  if (viewStyle.header) {
    const header = viewStyle.header;
    const headerFontFamily = mapFontToFontFamily(themeUtils, header.fontFamily);
    header.fontSize &&
      document.documentElement.style.setProperty(
        '--notebookHeaderSize',
        addPxSuffix(header.fontSize)
      );
    header.fontFamily &&
      document.documentElement.style.setProperty(
        '--notebookHeaderFontFamily',
        headerFontFamily
      );
    header.fontWeight &&
      document.documentElement.style.setProperty(
        '--notebookHeaderFontWeight',
        header.fontWeight
      );
    header.fontStyle &&
      document.documentElement.style.setProperty(
        '--notebookHeaderStyle',
        header.fontStyle
      );
  }

  if (viewStyle.title) {
    const title = viewStyle.title;
    const titleFontFamily = mapFontToFontFamily(themeUtils, title.fontFamily);
    title.fontSize &&
      document.documentElement.style.setProperty(
        '--notebookTitleSize',
        addPxSuffix(title.fontSize)
      );
    title.fontFamily &&
      document.documentElement.style.setProperty(
        '--notebookTitleFontFamily',
        titleFontFamily
      );
    title.fontWeight &&
      document.documentElement.style.setProperty(
        '--notebookTitleFontWeight',
        title.fontWeight
      );
    title.fontStyle &&
      document.documentElement.style.setProperty(
        '--notebookTitleStyle',
        title.fontStyle
      );
  }

  if (viewStyle.subTitle) {
    const subTitle = viewStyle.subTitle;
    const subTitleFontFamily = mapFontToFontFamily(
      themeUtils,
      subTitle.fontFamily
    );
    subTitle.fontSize &&
      document.documentElement.style.setProperty(
        '--notebookSubTitleSize',
        addPxSuffix(subTitle.fontSize)
      );
    subTitle.fontFamily &&
      document.documentElement.style.setProperty(
        '--notebookSubTitleFontFamily',
        subTitleFontFamily
      );
    subTitle.fontWeight &&
      document.documentElement.style.setProperty(
        '--notebookSubTitleFontWeight',
        subTitle.fontWeight
      );
    subTitle.fontStyle &&
      document.documentElement.style.setProperty(
        '--notebookSubTitleStyle',
        subTitle.fontStyle
      );
  }

  if (viewStyle.text) {
    const text = viewStyle.text;
    const textFontFamily = mapFontToFontFamily(themeUtils, text.fontFamily);
    text.fontSize &&
      document.documentElement.style.setProperty(
        '--notebookTextSize',
        addPxSuffix(text.fontSize)
      );
    text.fontFamily &&
      document.documentElement.style.setProperty(
        '--notebookTextFontFamily',
        textFontFamily
      );
    text.fontWeight &&
      document.documentElement.style.setProperty(
        '--notebookTextFontWeight',
        text.fontWeight
      );
    text.fontStyle &&
      document.documentElement.style.setProperty(
        '--notebookTextStyle',
        text.fontStyle
      );
  }
}